import PropTypes from "prop-types"
import React, { useEffect } from "react"
import { Controller, useFormContext } from "react-hook-form"
import { Input, Label, FormFeedback } from "reactstrap"

const TextareaInput = ({ label, id, required }) => {
  const methods = useFormContext()
  const { control, formState } = methods
  const { errors } = formState

  return (
    <React.Fragment>
      <Label>{label}</Label>
      <Controller
        name={id}
        control={control}
        render={({ field }) => (
          <>
            <textarea
              {...field}
              rows={3}
              className="form-control"
              id={id}
              required={required}
              onInvalid={e => {
                if (!!errors[id]) {
                  e.preventDefault()
                }
              }}
            />
            {errors[id]?.message ? (
              <FormFeedback type="invalid" className="d-block">
                {errors[id]?.message}
              </FormFeedback>
            ) : null}
          </>
        )}
      />
    </React.Fragment>
  )
}

TextareaInput.propTypes = {
  label: PropTypes.string,
  id: PropTypes.string,
  required: PropTypes.bool,
}

export default TextareaInput
